import moment from 'moment-timezone';
import React, { Children, cloneElement, useEffect, useState } from 'react';

import { SelectGroup } from '@flixbus/honeycomb-react';

import { STATION_TAB, USER_TAB } from './const';
import { TIMEZONE_TAB_TEXT } from './text';

import styles from './styles.module.css';

const TimezoneTabs = ({ children, stationTimezone, instanceId = 'default' }) => {
	const userTimeZone = moment.tz.guess();
	const [activeTab, setActiveTab] = useState(STATION_TAB);
	const [selectedTimezone, setSelectedTimezone] = useState(stationTimezone);
	const [renderKey, setRenderKey] = useState(0);

	useEffect(() => {
		const tz = activeTab === STATION_TAB ? stationTimezone : userTimeZone;
		setSelectedTimezone(tz);
	}, [activeTab, stationTimezone, userTimeZone]);

	// Reset when stationTimezone changes
	useEffect(() => {
		setActiveTab(STATION_TAB);
		setRenderKey((prev) => prev + 1);
	}, [stationTimezone]);

	const handleChange = (e) => {
		const tabId = e.target.value;
		setActiveTab(tabId);
	};

	const uniqueId = `${instanceId}-${renderKey}`;

	const options = [
		{
			id: `${STATION_TAB}-${uniqueId}`,
			value: STATION_TAB,
			name: `timezone-${uniqueId}`,
			label: TIMEZONE_TAB_TEXT.stationTime,
			checked: activeTab === STATION_TAB,
			onChange: handleChange,
		},
		{
			id: `${USER_TAB}-${uniqueId}`,
			value: USER_TAB,
			name: `timezone-${uniqueId}`,
			label: TIMEZONE_TAB_TEXT.myTime,
			checked: activeTab === USER_TAB,
			onChange: handleChange,
		},
	];

	const childrenWithTimezone = Children.map(children, (child) => {
		if (React.isValidElement(child)) {
			return cloneElement(child, {
				selectedTimezone: selectedTimezone,
			});
		}
		return child;
	});

	return (
		<div className={styles.tabWrapper}>
			<SelectGroup
				key={renderKey}
				aria-label="Select timezone"
				options={options}
				id={`timezone-select-group-${uniqueId}`}
				extraClasses={styles.timezoneGroup}
			/>
			<div data-timezone={selectedTimezone}>{childrenWithTimezone}</div>
		</div>
	);
};

export default TimezoneTabs;
